import { ReactElement } from "react"

import CreateEVACDeviceForm from "../../../../components/devices/lct/evac/createEVACDeviceForm"
import NewEVACDeviceVersionProvider from "../../../../components/devices/lct/evac/providers/newEVACDeviceVersionProvider"

const NewEVACDeviceVersion = (): ReactElement => (
    <NewEVACDeviceVersionProvider>
        <CreateEVACDeviceForm />
    </NewEVACDeviceVersionProvider>
)

export default NewEVACDeviceVersion
